import { Outlet } from 'react-router-dom'

import { MarketingDiscoveryStrip } from '@/components/marketing/marketing-discovery-strip'
import { SiteFooter } from '@/components/marketing/site-footer'
import { SiteHeader } from '@/components/marketing/site-header'
import { JsonLd } from '@/components/seo/json-ld'
import { getOrganizationSchema, getWebsiteSchema } from '@/lib/seo'

export default function MarketingLayout() {
  return (
    <div className="min-h-screen">
      <JsonLd data={getOrganizationSchema()} />
      <JsonLd data={getWebsiteSchema()} />
      <SiteHeader />
      <main>
        <Outlet />
        <MarketingDiscoveryStrip />
      </main>
      <SiteFooter />
    </div>
  )
}
